export default {
  API_URL:
    window?.env?.REACT_APP_API_URL || process.env.REACT_APP_API_URL || 'http://localhost:3005/api',
  VERSION: window?.env?.REACT_APP_VERSION || process.env.REACT_APP_VERSION || '0.0.1',
  NAME: window?.env?.REACT_APP_NAME || process.env.REACT_APP_NAME || 'urbaclient-front-local',
  REALM: window?.env?.REACT_APP_REALM || process.env.REACT_APP_REALM || 'Development',
  URL:
    window?.env?.REACT_APP_URL ||
    process.env.REACT_APP_URL ||
    'https://authenticate.urbasolar.com/auth',
  SSL_REQUIRED:
    window?.env?.REACT_APP_SSL_REQUIRED || process.env.REACT_APP_SSL_REQUIRED || 'external',
  CLIENTID:
    window?.env?.REACT_APP_CLIENTID || process.env.REACT_APP_CLIENTID || 'Urbaclient-Dev-Front',
  PUBLIC_CLIENT:
    window?.env?.REACT_APP_PUBLIC_CLIENT || process.env.REACT_APP_PUBLIC_CLIENT || true,
  CONFIDENTIAL_PORT:
    window?.env?.REACT_APP_CONFIDENTIAL_PORT || process.env.REACT_APP_CONFIDENTIAL_PORT || 0,
  GOOGLE_ANALYTICS:
    window?.env?.REACT_APP_GOOGLE_ANALYTICS || process.env.REACT_APP_GOOGLE_ANALYTICS || '',
  FILES_URL:
    window?.env?.REACT_APP_FILES_URL ||
    process.env.REACT_APP_FILES_URL ||
    'http://localhost:3005/files',
  CLIENT_API_URL:
    window?.env?.REACT_APP_CLIENT_API_URL ||
    process.env.REACT_APP_CLIENT_API_URL ||
    'https://dev-api.urbasolar.com/docs/clients',
  INTERNAL_FRONT_CLIENT_ID:
    window?.env?.REACT_APP_INTERNAL_FRONT_CLIENT_ID ||
    process.env.REACT_APP_INTERNAL_FRONT_CLIENT_ID ||
    '',
  INTERNAL_TENANT_ID:
    window?.env?.REACT_APP_INTERNAL_TENANT_ID || process.env.REACT_APP_INTERNAL_TENANT_ID || '',
  INTERNAL_BACK_CLIENT_ID:
    window?.env?.REACT_APP_INTERNAL_BACK_CLIENT_ID ||
    process.env.REACT_APP_INTERNAL_BACK_CLIENT_ID ||
    '',
  EXTERNAL_FRONT_CLIENT_ID:
    window?.env?.REACT_APP_EXTERNAL_FRONT_CLIENT_ID ||
    process.env.REACT_APP_EXTERNAL_FRONT_CLIENT_ID ||
    '',
  EXTERNAL_TENANT_ID:
    window?.env?.REACT_APP_EXTERNAL_TENANT_ID || process.env.REACT_APP_EXTERNAL_TENANT_ID || '',
  EXTERNAL_BACK_CLIENT_ID:
    window?.env?.REACT_APP_EXTERNAL_BACK_CLIENT_ID ||
    process.env.REACT_APP_EXTERNAL_BACK_CLIENT_ID ||
    '',
  EXTERNAL_SIGNIN_FLOW:
    window?.env?.REACT_APP_EXTERNAL_SIGNIN_FLOW || process.env.REACT_APP_EXTERNAL_SIGNIN_FLOW || '',
  EXTERNAL_RESET_PASSWORD_FLOW:
    window?.env?.REACT_APP_EXTERNAL_RESET_PASSWORD_FLOW ||
    process.env.REACT_APP_EXTERNAL_RESET_PASSWORD_FLOW ||
    '',
  EXTERNAL_DOMAIN:
    window?.env?.REACT_APP_EXTERNAL_DOMAIN || process.env.REACT_APP_EXTERNAL_DOMAIN || '',
  FRONT_REDIRECT_URI:
    window?.env?.REACT_APP_FRONT_REDIRECT_URI || process.env.REACT_APP_FRONT_REDIRECT_URI || '',
}
